
  window.addEventListener('load', () => {
    const cards = document.querySelectorAll('.js-cardHeight');
    let maxHeight = 0;

    // 一度リセット（レスポンシブ対応のため）
    cards.forEach(card => {
      card.style.height = 'auto';
    });

    // 最大高さを取得
    cards.forEach(card => {
      const height = card.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    // 最大高さに揃える
    cards.forEach(card => {
      card.style.height = maxHeight + 'px';
    });
  });

  // リサイズ時にも再調整（オプション）
  window.addEventListener('resize', () => {
    const cards = document.querySelectorAll('.js-cardHeight');
    let maxHeight = 0;

    cards.forEach(card => {
      card.style.height = 'auto';
    });

    cards.forEach(card => {
      const height = card.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    cards.forEach(card => {
      card.style.height = maxHeight + 'px';
    });
  });
